import React, { useState } from 'react';
import { Accordion, AccordionItem } from '@carbon/react';
import '@/app/styles/accordion-carbon.scss';
export interface AccordionItemType {
  key: string;
  title: React.ReactNode;
  content: React.ReactNode;
  openByDefault?: boolean;
}

interface CarbonAccordionProps {
  items: AccordionItemType[];
  align?: 'start' | 'end';
  size?: 'sm' | 'md' | 'lg';
  openByDefault?: boolean;
  singleOpen?: boolean;
}

export default function CarbonAccordion({
  items,
  align = 'end',
  size = 'md',
  openByDefault = false,
  singleOpen = false,
}: CarbonAccordionProps) {
  // Find the first item that should be open by default
  const initialOpenKey = items.find(item => item.openByDefault)?.key || null;
  const [openItem, setOpenItem] = useState<string | null>(singleOpen ? initialOpenKey : null);

  const handleToggle = (itemKey: string, isOpen: boolean) => {
    if (singleOpen) {
      setOpenItem(isOpen ? itemKey : null);
    }
  };

  return (
    <Accordion align={align} size={size}>
      {items.map(item => (
        <AccordionItem
          key={item.key}
          title={item.title}
          open={singleOpen ? openItem === item.key : item?.openByDefault || openByDefault}
          onHeadingClick={e => {
            const isCurrentlyOpen = singleOpen ? openItem === item.key : undefined;
            handleToggle(item.key, !isCurrentlyOpen);
          }}
        >
          {item.content}
        </AccordionItem>
      ))}
    </Accordion>
  );
}
